module.exports = __webpack_public_path__ + "media/images/affiliation_logos/affiliate_logo_pennsylvania-56601e345618b569d524a77d81b2e3bc.png";